module.exports = __webpack_public_path__ + "media/images/flags/32/Austria-a9d0aded2fbef0a437a44fcbf553fccd.png";